import { useFormik } from 'formik';
import axios from 'axios';
import { useState } from 'react';

function ApplyDispatcher() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState('');

    const formik = useFormik({
        initialValues: {
            firstname: '',
            middlename: '',
            lastname: '',
            email: '',
            phone: '',
            dob: '',
            ssnno: '',
            address: '',
            postalcode: '',
            applicationtype: '',
            experience: ''
        },
        validate: values => {
            const errors = {};
            if (!values.firstname) errors.firstname = "First name is required";
            if (!values.lastname) errors.lastname = "Last name is required";
            if (!values.email) {
                errors.email = "Email is required";
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = "Invalid email address";
            }
            if (!values.phone) errors.phone = "Phone number is required";
            if (!values.dob) errors.dob = "Date of birth is required";
            if (!values.ssnno) errors.ssnno = "SSN/SIN is required";
            if (!values.address) errors.address = "Address is required";
            if (!values.postalcode) errors.postalcode = "Postal code is required";
            if (!values.applicationtype) errors.applicationtype = "Job Application Type is required";
            if (!values.experience) errors.experience = "Years of Experience is required";
            return errors;
        },
        onSubmit: async values => {
            setIsSubmitting(true);
            setSubmitError('');
            setSubmitSuccess(false);

            try {
                const response = await axios.post(
                    // 'http://localhost:8080/mann/careerPost.php',
                    'https://manncarriers.com/server/careerPost.php',
                    values,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (response.data.success) {
                    setSubmitSuccess(true);
                    formik.resetForm();
                } else {
                    setSubmitError(response.data.message || 'Submission failed. Please try again.');
                }
            } catch (error) {
                console.error('Submission error:', error);
                setSubmitError('Something went wrong. Please try again.');
            } finally {
                setIsSubmitting(false);
            }
        }
    });

    return (
        <>
            <div id="hero" className="Starter section dark-background">
                <img src="assets/img/image11.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                <div className="container">
                    <div className="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-xl-6 col-lg-8">
                            <h2>Apply for the job</h2>
                            <p className="mt-3">Explore our current openings and take the next step toward a rewarding career in transportation with us.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-offwhite py-5">
                <div className="container-xl my-5 ">
                    <div className="row justify-content-between">
                        
                        <div className="col-lg-5 ">
                            <h4 className="text-uppercase" data-aos="fade-up" data-aos-delay="100">We Are Hiring</h4>
                            <h1 className="display-5 fw-bold mb-4" data-aos="fade-up" data-aos-delay="200">Apply for a Role at<br />Mann Carriers LLC</h1>
                            <p className="text-muted fs-5" data-aos="fade-up" data-aos-delay="300">
                                Looking for a career where your skills truly drive success? Mann Carriers LLC is hiring dedicated professionals ready to make an impact in the world of logistics. Browse our current openings and take your first step toward a stable and rewarding future.
                            </p>
                        </div>

                        <div className="col-lg-7 col-xl-6 " >
                            <div className="application-form custom p-4 pt-0">
                                <h2 className="mb-4" data-aos="fade-up" data-aos-delay="100">Complete the Form Below to Help Us Understand Your Experience</h2>

                                <form onSubmit={formik.handleSubmit} data-aos="fade-up" data-aos-delay="300">
                                    <div className="row">
                                        <div className="col-sm-4" >
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="First Name"
                                                name="firstname"
                                                onChange={formik.handleChange}
                                                value={formik.values.firstname}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.firstname && (
                                                    formik.errors.firstname
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Middle Name"
                                                name="middlename"
                                                onChange={formik.handleChange}
                                                value={formik.values.middlename}
                                            />
                                            <div className="small text-danger errorM"></div>
                                        </div>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Last Name"
                                                name="lastname"
                                                onChange={formik.handleChange}
                                                value={formik.values.lastname}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.lastname && (
                                                    formik.errors.lastname
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-7">
                                            <input
                                                type="email"
                                                className="form-control form-control-lg"
                                                placeholder="Email"
                                                name="email"
                                                onChange={formik.handleChange}
                                                value={formik.values.email}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.email && (
                                                    formik.errors.email
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-5">
                                            <input
                                                type="tel"
                                                className="form-control form-control-lg"
                                                placeholder="Phone"
                                                name="phone"
                                                pattern="(\+1)?[\-\.\s]?\(?\d{3}\)?[\-\.\s]?\d{3}[\-\.\s]?\d{4}"
                                                onChange={formik.handleChange}
                                                value={formik.values.phone}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.phone && (
                                                    formik.errors.phone
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-4 position-relative">
                                            <input
                                                type="date"
                                                className="form-control form-control-lg"
                                                name="dob"
                                                onChange={formik.handleChange}
                                                value={formik.values.dob}
                                                onBlur={(e) => e.target.style.color = formik.values.dob ? '#000' : '#aaa'}
                                                style={{ color: formik.values.dob ? '#000' : '#fff' }}
                                            />
                                            {!formik.values.dob && (
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        left: '30px',
                                                        top: '17px',
                                                        color: '#aaa',
                                                        pointerEvents: 'none',
                                                    }}
                                                >
                                                    Date of Birth
                                                </span>
                                            )}
                                            <div className="small text-danger errorM">
                                                {formik.errors.dob && (
                                                    formik.errors.dob
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="SSN\SIN No."
                                                name="ssnno"
                                                onChange={formik.handleChange}
                                                value={formik.values.ssnno}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.ssnno && (
                                                    formik.errors.ssnno
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Full Address"
                                                name="address"
                                                onChange={formik.handleChange}
                                                value={formik.values.address}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.address && (
                                                    formik.errors.address
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Pin Code"
                                                name="postalcode"
                                                onChange={formik.handleChange}
                                                value={formik.values.postalcode}
                                            />
                                            <div className="small text-danger errorM">
                                                {formik.errors.postalcode && (
                                                    formik.errors.postalcode
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <select
                                                className="form-select form-select-lg"
                                                name="applicationtype"
                                                onChange={formik.handleChange}
                                                value={formik.values.applicationtype}
                                            >
                                                <option value="" disabled>Job Application Type</option>
                                                <option value="Dispatcher">Dispatcher</option>
                                                <option value="Truck Driver">Truck Driver</option>
                                            </select>
                                            <div className="small text-danger errorM">
                                                {formik.errors.applicationtype && (
                                                    formik.errors.applicationtype
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <select
                                                className="form-select form-select-lg"
                                                name="experience"
                                                onChange={formik.handleChange}
                                                value={formik.values.experience}
                                            >
                                                <option value="" disabled>Years of Experience</option>
                                                <option value="No Experience">No Experience</option>
                                                <option value="1-2 years">1-2 years</option>
                                                <option value="3-5 years">3-5 years</option>
                                                <option value="5+ years">5+ years</option>
                                            </select>
                                            <div className="small text-danger errorM">
                                                {formik.errors.experience && (
                                                    formik.errors.experience
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {submitError && (
                                        <div className="alert alert-danger "><i className="bi bi-exclamation-triangle"></i> {submitError}</div>
                                    )}
                                    {submitSuccess && (
                                        <div className="alert alert-success "><i className="bi bi-check-circle"></i> Application submitted successfully!</div>
                                    )}

                                    <button
                                        type="submit"
                                        className="submit-btn mt-3"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Submitting...' : 'Submit Now '}
                                        <i className="bi bi-arrow-right"></i>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ApplyDispatcher;